import React, { useState, useEffect } from 'react';
import { WEDDING } from '../utils/config';

export default function Countdown() {
  const [t, setT] = useState({ d:'--',h:'--',m:'--',s:'--' });

  useEffect(() => {
    const tick = () => {
      const diff = new Date(WEDDING.countdownDate) - new Date();
      if (diff <= 0) { setT({ d:'00',h:'00',m:'00',s:'00' }); return; }
      setT({
        d: String(Math.floor(diff/86400000)).padStart(2,'0'),
        h: String(Math.floor((diff%86400000)/3600000)).padStart(2,'0'),
        m: String(Math.floor((diff%3600000)/60000)).padStart(2,'0'),
        s: String(Math.floor((diff%60000)/1000)).padStart(2,'0'),
      });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <section style={{ background:'var(--deep)',padding:'60px 32px',textAlign:'center',position:'relative',overflow:'hidden' }}>
      <div style={{ position:'absolute',inset:0,background:'radial-gradient(ellipse at center,rgba(107,155,111,.1) 0%,transparent 65%)',pointerEvents:'none' }} />
      <span className="section-tag" style={{ color:'var(--gold)',justifyContent:'center',display:'flex',marginBottom:'30px' }}>Counting down to forever</span>
      <div style={{ display:'flex',justifyContent:'center',alignItems:'flex-start',gap:'32px',flexWrap:'wrap',position:'relative',zIndex:1 }}>
        {[['Days',t.d],['Hours',t.h],['Minutes',t.m],['Seconds',t.s]].map(([unit,val]) => (
          <div key={unit} style={{ textAlign:'center' }}>
            <div style={{ fontFamily:'var(--font-serif)',fontSize:'clamp(50px,7vw,76px)',fontWeight:300,color:'#fff',lineHeight:1,textShadow:'0 4px 20px rgba(126,207,184,.2)' }}>{val}</div>
            <div style={{ fontSize:'9px',letterSpacing:'.22em',textTransform:'uppercase',color:'var(--sage-l)',marginTop:'6px' }}>{unit}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
